import axios from "axios"
import library from "../../../utils/Library"

const ADMIN_ACCESS_USER_API_BASE_URL =
  library.getBaseAPIUrl("e_authz")

const getAdminAccessUserAuthConfig = () => {
  // TODO: Reemplazar esta variable por la forma en que hoy obtienes el bearer token.
  const token = sessionStorage.getItem('token')
  const headers = {
    "Content-Type": "application/json",
  }

  headers.Authorization = `Bearer ${token}`


  return {
    headers,
  }
}

export const getAllAppRolesEAuthz = (appCode) => {
  return axios.get(`${ADMIN_ACCESS_USER_API_BASE_URL}/getAllAppRolEAuthz`, {
    ...getAdminAccessUserAuthConfig(),
    params: { appCode },
  })
}

export const getOrgApplicationAccessStatusEAuthz = ({ appCode, organizationId }) => {
  return axios.get(`${ADMIN_ACCESS_USER_API_BASE_URL}/getOrgApplicationAccessStatusEAuthz`, {
    ...getAdminAccessUserAuthConfig(),
    params: {
      appCode,
      organizationId,
    },
  })
}

export const addOrgApplicationInstanceEAuthz = (body) => {
  return axios.post(
    `${ADMIN_ACCESS_USER_API_BASE_URL}/addOrgApplicationInstanceEAuthz`,
    body,
    getAdminAccessUserAuthConfig()
  )
}

export const updateOrgApplicationInstanceEAuthz = (body) => {
  return axios.put(
    `${ADMIN_ACCESS_USER_API_BASE_URL}/updateOrgApplicationInstanceEAuthz`,
    body,
    getAdminAccessUserAuthConfig()
  )
}

export const getUserApplicationInstanceEAuthz = ({
  applicationCode,
  userId,
  applicationInstanceId,
}) => {
  return axios.get(`${ADMIN_ACCESS_USER_API_BASE_URL}/getUserApplicationInstanceEAuthz`, {
    ...getAdminAccessUserAuthConfig(),
    params: {
      applicationCode,
      userId,
      applicationInstanceId,
    },
  })
}

export const addUserApplicationInstanceAccessEAuthz = (body) => {
  return axios.post(
    `${ADMIN_ACCESS_USER_API_BASE_URL}/addUserApplicationInstanceAccessEAuthz`,
    body,
    getAdminAccessUserAuthConfig()
  )
}

export const updateUserApplicationInstanceAccessEAuthz = (body) => {
  return axios.put(
    `${ADMIN_ACCESS_USER_API_BASE_URL}/UpdateUserApplicationInstanceAccessEAuthz`,
    body,
    getAdminAccessUserAuthConfig()
  )
}

export const getUserGrantedAppRoleEAuthz = ({ appCode, applicationInstanceId, userId }) => {
  return axios.get(`${ADMIN_ACCESS_USER_API_BASE_URL}/getUserGrantedAppRoleEAuthz`, {
    ...getAdminAccessUserAuthConfig(),
    params: {
      appCode,
      applicationInstanceId,
      userId,
    },
  })
}

export const grantAppRoleToUserEAuthz = (body) => {
  return axios.post(
    `${ADMIN_ACCESS_USER_API_BASE_URL}/GrantAppRoleToUserEAuthz`,
    body,
    getAdminAccessUserAuthConfig()
  )
}

export const revokeAppRoleFromUserEAuthz = (body) => {
  return axios.delete(`${ADMIN_ACCESS_USER_API_BASE_URL}/RevokeAppRoleFromUserEAuthz`, {
    ...getAdminAccessUserAuthConfig(),
    data: body,
  })
}

